import PropTypes from "prop-types";
import LandingCard from "./LandingCard";
import useI18n from "../hooks/useI18n";

const Landing6th = ({ locale }) => {
    const { getCountry } = useI18n();
    const isGlobal = getCountry() === 'global';

    const cards = isGlobal ? [
        { key: 'card1', title: locale.cardGlobalTitleOne, content: locale.cardGlobalContentOne, country: locale.cardGlobalCountryOne },
        { key: 'card2', title: locale.cardGlobalTitleTwo, content: locale.cardGlobalContentTwo, country: locale.cardGlobalCountryTwo },
        { key: 'card3', title: locale.cardGlobalTitleThree, content: locale.cardGlobalContentThree, country: locale.cardGlobalCountryThree },
        { key: 'card4', title: locale.cardGlobalTitleFour, content: locale.cardGlobalContentFour, country: locale.cardGlobalCountryFour },
        { key: 'card5', title: locale.cardGlobalTitleFive, content: locale.cardGlobalContentFive, country: locale.cardGlobalCountryFive }
    ] : [
        { key: 'card1', title: locale.cardTitleOne, content: locale.cardContentOne, country: null },
        { key: 'card2', title: locale.cardTitleTwo, content: locale.cardContentTwo, country: null },
        { key: 'card3', title: locale.cardTitleThree, content: locale.cardContentThree, country: null },
        { key: 'card4', title: locale.cardTitleFour, content: locale.cardContentFour, country: null },
        { key: 'card5', title: locale.cardTitleFive, content: locale.cardContentFive, country: null }
    ];

    return (
        <div className='landing-element-container' id="landing-page-6th">
            <div className='landing-element-content'>
                <div className="row">
                    <div className='col-lg-6 col-md-8 col-xs-12'>
                        <h1>{locale.title}</h1>
                        <p>{locale.subtitle}</p>
                    </div>
                </div>
                <div className="row landing-element-card-row g-0">
                    {cards.map((card) => (
                        <LandingCard
                            key={card.key}
                            title={card.title}
                            content={card.content}
                            country={card.country}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

Landing6th.propTypes = {
    locale: PropTypes.object.isRequired
}

export default Landing6th;
